import React, { useState, useEffect, useRef } from "react";
import TopImage from "../components/Slideshow/TopImage";
import TopBar from "../components/Header/TopBar";
import Information from "../components/Slideshow/InformationPoint";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { Swiper as SwiperClass } from "swiper";

import "swiper/css";
import { Endpoint, LocationData, ApiResponse } from "../types/";
//import images
import ImagemSede from "../styles/images/jpg/Sede.jpg";
import ImagemEstaleiro from "../styles/images/jpg/Estaleiro.jpg";
import ImagemReservatorio from "../styles/images/jpg/Reservatorio.jpg";
import ImagemPasseioDunas from "../styles/images/jpg/Dunas.jpg";
import ImagemSede2 from "../styles/images/jpg/Sede2.jpg";
import ImagemVilaSol from "../styles/images/jpg/VilaSol.jpg";
import ImagemViveiros from "../styles/images/jpg/Viveiros.jpg";
const endpoints: Endpoint[] = [
  {
    title: "na Sede da Inframoura",
    endpoint:
      "https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/63f3ce96-02ae-4f31-a106-c4454ac30da0?cache=true&identifier=TV_Production",
    image: ImagemSede,
  },
  {
    title: "no Passeio das Dunas",
    endpoint:
      "	https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/107054ed-05b1-4882-a110-06dca9a39c49?cache=true&identifier=TV_Production",
    image: ImagemPasseioDunas,
  },
  {
    title: "Estaleiros",
    endpoint:
      "https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/d0a8990b-94df-4c82-b0b0-68c6ca517fba?cache=true&identifier=TV_Production",
    image: ImagemEstaleiro,
  },
  {
    title: "nos Reservatórios de Água de Vila Sol",
    endpoint:
      "https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/dbe2022f-a805-4dcb-a00f-4658b5058305?cache=true&identifier=TV_Production",
    image: ImagemVilaSol,
  },
  {
    title: "nos Reservatórios de Água R6",
    endpoint:
      "https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/83ae004c-b1c5-4d0c-a810-d09d02ef6b1d?cache=true&identifier=TV_Production",
    image: ImagemReservatorio,
  },
  {
    title: "nos Viveiros da Inframoura",
    endpoint: "https://staging.unyk.tv/api/energypanel/e5bb7d51-be2b-4a90-837b-2530efc010c1/12492182?cache=true&identifier=TV_Production",
    image: ImagemViveiros,
  },
  {
    title: "Total da Inframoura",
    endpoint: "",
    image: ImagemSede2,
  },
];

// Calculate and format time difference
const formatTimeSince = (timestamp: string): string => {
  const now = new Date();
  const updateTime = new Date(timestamp);

  const diffMs = now.getTime() - updateTime.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes < 60) {
    return `${diffMinutes} minuto${diffMinutes !== 1 ? "s" : ""}`;
  } else {
    const diffHours = Math.floor(diffMinutes / 60);
    return `${diffHours} hora${diffHours !== 1 ? "s" : ""}`;
  }
};

// Format unit display to ensure proper spacing
const formatUnitDisplay = (text: string, unit: string): string => {
  if (!text) return "";

  if (text.includes(` ${unit}`)) return text;

  const regex = new RegExp(`(\\d+[.,]?\\d*)${unit}`, "g");
  if (text.includes(unit) && regex.test(text)) {
    return text.replace(regex, `$1 ${unit}`);
  }

  if (!text.includes(unit)) {
    return `${text} ${unit}`;
  }

  return text;
};

const Home: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState<LocationData[]>([]);
  const swiperRef = useRef<SwiperClass | null>(null);
  // Initialize with fallback data
  useEffect(() => {
    const fallbackData = createFallbackTotalData();
    setData([fallbackData]);
  }, []);

  // Create fallback total data when APIs are not responding
  const createFallbackTotalData = (): LocationData => {
    const totalEndpoint = endpoints.find((e) => e.title === "Total da Inframoura");

    return {
      title: totalEndpoint?.title || "Total da Inframoura",
      image: totalEndpoint?.image || ImagemSede2,
      items: [
        {
          title: "Potência FV actual",
          value: "---",
          unit: "kW",
          description: "",
          timestamp: "Sem dados",
          footer: { all: "" },
          descp: {},
        },
        {
          title: "Energia fotovoltaica",
          value: "---",
          unit: "kWh",
          description: "",
          timestamp: "Sem dados",
          footer: { all: "" },
          descp: {},
        },
        {
          title: "Redução das emissões de CO2",
          value: "---",
          unit: "kg",
          description: "",
          timestamp: "Sem dados",
          footer: { all: "" },
          descp: {},
        },
        {
          title: "Informações sobre o sistema",
          value: "---",
          unit: "kWp",
          description: "",
          timestamp: "Sem dados",
          footer: {},
          descp: {},
        },
      ],
    };
  };

  const compareDates = (date1: string, date2: string): number => {
    const [day1, month1, year1] = date1.split("/").map(Number);
    const [day2, month2, year2] = date2.split("/").map(Number);

    // Compare years first
    if (year1 !== year2) return year1 - year2;
    // Then months
    if (month1 !== month2) return month1 - month2;
    // Then days
    return day1 - day2;
  };

  //Swiper control for single slide
  useEffect(() => {
    const swiper = swiperRef.current;
    if (!swiper) return;

    const single = data.length < 2;

    if (single) {
      swiper.autoplay?.stop();
    } else {
      swiper.autoplay?.start();
    }
  }, [data.length]);

  //Auto refresh
  useEffect(() => {
    const RELOAD_MS = 2 * 60 * 60 * 1000; // 2 hours
    const id = window.setTimeout(() => {
      window.location.replace(window.location.href);
    }, RELOAD_MS);
    return () => clearTimeout(id);
  }, []);

  const transformAlternativeFormat = (data: any): ApiResponse[] => {
    if (!data || (!data.PowerFV && !data[0])) {
      return [];
    }
    if (data.PowerFV && data.EnergyFV && data.PlantSystemPower) {
      const transformedData: ApiResponse[] = [
        {
          title: "Potência FV actual",
          value: String(data.PowerFV.TodayPower || 0),
          valueunit: "kW",
          timestamp: data.PowerFV.Date || "",
          footer: { all: "" },
          descp: { descp: data.PowerFV.StrDate || "" },
        },
        {
          title: "Energia fotovoltaica",
          value: String((data.EnergyFV.Energy || 0).toFixed(2)),
          valueunit: "kWh",
          timestamp: data.PowerFV.Date || new Date().toISOString(),
          footer: { all: formatUnitDisplay(`Total: ${(data.EnergyFV.Total / 1000000).toFixed(2)}`, "MWh") },
          descp: {
            descp: (() => {
              const today = new Date();
              const todayFormatted = `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()}`;

              if (data.PowerFV.StrDate === todayFormatted) {
                return "Hoje";
              } else {
                return `${data.PowerFV.StrDate || ""}`;
              }
            })(),
          },
        },
        {
          title: "Redução das emissões de CO2",
          value: String((data.PlantSystemPower.CO2 / 1000).toFixed(2) || 0),
          valueunit: "kg",
          timestamp: data.PowerFV.Date || new Date().toISOString(),
          footer: { all: formatUnitDisplay(`Total: ${(data.PlantSystemPower.CO2Total / 1000 / 1000).toFixed(2)}`, " t") },
          descp: {
            descp: (() => {
              const today = new Date();
              const todayFormatted = `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()}`;

              if (data.PowerFV.StrDate === todayFormatted) {
                return "Hoje";
              } else {
                return `${data.PowerFV.StrDate || ""}`;
              }
            })(),
          },
        },
        {
          title: "Informações sobre o sistema",
          value: "",
          valueunit: "",
          timestamp: data.PlantSystemPower.Date || new Date().toISOString(),
          footer: { all: "Informações do sistema fotovoltaico" },
          descp: {
            parts: [
              {
                label: "Potência Instalada",
                value: `${(data.PlantSystemPower.SystemPower / 1000).toFixed(2).replace(".", ",")} kWp`,
              },
              {
                label: "Data de instalação",
                value: data.PlantSystemPower.StrDate || "",
              },
            ],
          },
        },
      ];
      return transformedData;
    }
    return data;
  };

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        // Process all endpoints except Total
        const totalEndpoint = endpoints.find((e) => e.title === "Total da Inframoura");
        const regularEndpoints = endpoints.filter((e) => e.title !== "Total da Inframoura");

        const results = await Promise.allSettled(
          regularEndpoints.map(async (endpoint) => {
            try {
              const response = await fetch(endpoint.endpoint);
              const jsonData = await response.json();

              // Flag to identify if this is an alternative format (XML)
              const isAlternativeFormat = jsonData && jsonData.PowerFV && jsonData.EnergyFV;

              // Transform the data if it's in the alternative format
              const json: ApiResponse[] = transformAlternativeFormat(jsonData);

              // If response is not ok or no data, return null
              if (!response.ok || !json || json.length === 0) {
                return null;
              }

              const processedItems = [];

              for (let i = 0; i <= 3; i++) {
                if (json[i]) {
                  let value = json[i].value;
                  if (i === 0) {
                    // Convert value to kW
                    value = (parseFloat(value) / 1000).toFixed(2);
                  } else if (i === 1 && json[i].valueunit === "Wh") {
                    // Convert Wh to kWh only for alternative format
                    value = (parseFloat(value) / 1000).toFixed(2);
                  } else if (i === 2 || i === 3) {
                    value = parseFloat(value).toFixed(2);
                  }
                  let description = "";
                  if (json[i].descp) {
                    if (typeof json[i].descp === "object") {
                      if (json[i].descp.all) {
                        description = String(json[i].descp.all);
                      } else if (json[i].descp.descp) {
                        description = String(json[i].descp.descp);
                      } else {
                        description = "Info disponível";
                      }
                    } else {
                      description = String(json[i].descp);
                    }
                  }

                  processedItems.push({
                    title: json[i].title,
                    value: value,
                    unit: i === 1 ? "kWh" : json[i].valueunit,
                    description: description,
                    timestamp: formatTimeSince(json[i].timestamp),
                    footer: json[i].footer,
                    descp: json[i].descp,
                    originalValue: json[i].value,
                    originalUnit: json[i].valueunit,
                    isAlternativeFormat: isAlternativeFormat,
                  });
                }
              }

              // Only return data if we have processed items
              if (processedItems.length > 0) {
                return {
                  title: endpoint.title,
                  image: endpoint.image,
                  items: processedItems,
                  isAlternativeFormat: isAlternativeFormat,
                };
              }

              return null;
            } catch (error) {
              console.error(`Error fetching data from ${endpoint.endpoint}:`, error);
              return null;
            }
          })
        );

        // Filter out null values and empty items arrays
        const validData = results
          .filter((result) => result.status === "fulfilled")
          .map((result) => (result as PromiseFulfilledResult<any>).value)
          .filter((item): item is any => item !== null && item.items && item.items.length > 0);

        // Calculate totals from valid data
        if (validData.length > 0 && totalEndpoint) {
          let totalCurrentPower = 0;
          let totalEnergyProduced = 0;
          let totalMWhProduced = 0;
          let totalCO2Reduction = 0;
          let totalCO2ReductionTons = 0;
          let totalInstalledPower = 0;
          let oldestInstallationDate = "";
          let latestUpdate = "";

          // Track the oldest installation date
          const dateRegex = /(\d{2}\/\d{2}\/\d{4})/;

          // Format integer values without decimal places, and decimal values with 2 places
          const formatNumber = (num: number): string => {
            if (Number.isInteger(num)) {
              return String(Math.round(num));
            } else {
              return num.toFixed(2).replace(".", ",");
            }
          };

          // Sum up values from all locations
          validData.forEach((location) => {
            // Current Power (index 0)
            if (location.items[0]) {
              const originalValue = parseFloat(location.items[0].originalValue?.toString() || "0");
              if (!isNaN(originalValue)) {
                totalCurrentPower += originalValue;
              }

              // Track the latest update time
              if (!latestUpdate || location.items[0].timestamp) {
                latestUpdate = location.items[0].timestamp;
              }
            }

            // Energy Produced (index 1)
            if (location.items[1]) {
              const originalValue = parseFloat(location.items[1].originalValue?.toString().replace(",", ".") || "0");
              if (!isNaN(originalValue)) {
                const energyInKWh = location.isAlternativeFormat ? originalValue / 1000 : originalValue;
                totalEnergyProduced += energyInKWh;
              }

              // Extract MWh total from footer if available
              if (location.items[1].footer?.all) {
                const mwhMatch = location.items[1].footer.all.match(/(\d+[.,]?\d*)\s*MWh/);
                if (mwhMatch && mwhMatch[1]) {
                  const mwhValue = parseFloat(mwhMatch[1].replace(",", "."));
                  if (!isNaN(mwhValue)) {
                    totalMWhProduced += mwhValue;
                  }
                }
              }
            }

            // CO2 Reduction (index 2)
            if (location.items[2]) {
              const originalValue = parseFloat(location.items[2].originalValue?.toString().replace(",", ".") || "0");
              if (!isNaN(originalValue)) {
                totalCO2Reduction += originalValue;
              }

              // Extract tons total from footer if available
              if (location.items[2].footer?.all) {
                // Handle different possible formats like "Total: 70t" or "Total: 70 t" or "Total: 70,5 t"
                const tonsMatch = location.items[2].footer.all.match(/Total: (\d+[.,]?\d*)\s*t/);
                if (tonsMatch && tonsMatch[1]) {
                  const tonsValue = parseFloat(tonsMatch[1].replace(",", "."));
                  if (!isNaN(tonsValue)) {
                    totalCO2ReductionTons += tonsValue;
                  }
                } else {
                  // Try alternative format that might directly contain a number with t
                  const directTonsMatch = location.items[2].footer.all.match(/(\d+[.,]?\d*)t/);
                  if (directTonsMatch && directTonsMatch[1]) {
                    const tonsValue = parseFloat(directTonsMatch[1].replace(",", "."));
                    if (!isNaN(tonsValue)) {
                      totalCO2ReductionTons += tonsValue;
                    }
                  }
                }
              }
            }

            // Installed Power (index 3)
            if (location.items[3] && location.items[3].descp?.parts) {
              // Get installation power
              const powerText = location.items[3].descp.parts[0]?.value || "";
              const powerMatch = powerText.match(/(\d+[,.]?\d*)/);

              if (powerMatch) {
                const installedPower = parseFloat(powerMatch[0].replace(",", "."));
                if (!isNaN(installedPower)) {
                  totalInstalledPower += installedPower;
                }
              }

              // Get installation date
              const installDateText = location.items[3].descp.parts[1]?.value || "";
              const dateMatch = installDateText.match(dateRegex);

              if (dateMatch && dateMatch[0]) {
                const currentDate = dateMatch[0];
                // Compare dates (dd/mm/yyyy format)
                if (!oldestInstallationDate || compareDates(currentDate, oldestInstallationDate) < 0) {
                  oldestInstallationDate = currentDate;
                }
              }
            }
          });

          // Create total items with the same structure
          const totalItems = [
            {
              title: "Potência FV actual",
              value: isNaN(totalCurrentPower / 1000) ? "---" : (totalCurrentPower / 1000).toFixed(2),
              unit: "kW",
              description: "Potência total atual",
              timestamp: latestUpdate || "Última atualização",
              footer: { all: "Potência total atual" },
              descp: { descp: "Hoje" },
            },
            {
              title: "Energia fotovoltaica",
              value: isNaN(totalEnergyProduced * 1000) ? "---" : (totalEnergyProduced * 1000).toFixed(2),
              unit: "kWh",
              description: totalMWhProduced > 0 ? formatUnitDisplay(`Total: ${formatNumber(totalMWhProduced)}`, "MWh") : "Dados não disponíveis MWh",
              timestamp: latestUpdate || "Última atualização",
              footer: { all: totalMWhProduced > 0 ? formatUnitDisplay(`Total: ${formatNumber(totalMWhProduced)}`, "MWh") : "Dados não disponíveis MWh" },
              descp: { descp: "Hoje" },
            },
            {
              title: "Redução das emissões de CO2",
              value: isNaN(totalCO2Reduction) ? "---" : totalCO2Reduction.toFixed(2).replace(".", ","),
              unit: "kg",
              description: totalCO2ReductionTons > 0 ? "Total: " + formatUnitDisplay(`${formatNumber(totalCO2ReductionTons)}`, "t") : "Dados não disponíveis",
              timestamp: latestUpdate || "Última atualização",
              footer: {
                all: totalCO2ReductionTons > 0 ? "Total: " + formatUnitDisplay(`${formatNumber(totalCO2ReductionTons)}`, "t") : "Dados não disponíveis",
              },
              descp: { descp: "Hoje" },
            },
            {
              title: "Informações sobre o sistema",
              value: isNaN(totalInstalledPower) ? "---" : "",
              unit: "kWp",
              description: `Número de instalações: ${validData.length}`,
              timestamp: "Potência Total Instalada",
              footer: { all: "Informações do sistema fotovoltaico" },
              descp: {
                parts: [
                  {
                    label: "Potência Total Instalada",
                    value: isNaN(totalInstalledPower) ? "--- kWp" : `${totalInstalledPower.toFixed(2).replace(".", ",")} kWp`,
                  },
                  {
                    label: "Colocação em serviço: ",
                    value: oldestInstallationDate || "Desconhecida",
                  },
                ],
              },
            },
          ];

          // Add total data to valid data
          validData.push({
            title: totalEndpoint.title,
            image: totalEndpoint.image,
            items: totalItems,
          });

          const currentIndex = swiperRef.current?.realIndex || 0;

          setData(validData);

          setTimeout(() => {
            if (swiperRef.current) {
              swiperRef.current.update();
              swiperRef.current.slideToLoop(currentIndex);
            }
          }, 0);
        } else {
          const fallbackData = createFallbackTotalData();
          setData([fallbackData]);
        }
      } catch (error) {
        const fallbackData = createFallbackTotalData();
        setData([fallbackData]);
      }
    };

    fetchData();

    const interval = setInterval(fetchData, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      <div className="header-container">
        <TopBar />
        <div className="slideshow-wrapper" style={{ paddingBottom: "80px" }}>
          <Swiper
            key={data.length}
            onSwiper={(swiper: SwiperClass) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper: SwiperClass) => {
              setActiveIndex(swiper.realIndex);
            }}
            modules={[Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            speed={800}
            pagination={{
              clickable: true,
              el: ".swiper-pagination-custom",
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              reverseDirection: false,
            }}
            loop={true}
            observer
            className="information-swiper"
          >
            {data.map((locationData, index) => (
              <SwiperSlide key={locationData.title} virtualIndex={index}>
                <TopImage imageSrc={locationData.image} alt={`${locationData.title} Location`} />
                <Information locationData={locationData} />
              </SwiperSlide>
            ))}
          </Swiper>

          <div
            className="swiper-pagination-custom"
            style={{
              position: "absolute",
              bottom: "-10px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              zIndex: 10,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Home;
